import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import BankAccountCard from 'components/Dashboard/BankAccountCard';
import { Container, Stack } from '@mui/material';
import { getMoneyContainer, updatedAccount } from 'redux/slices/getMoneyContainerSlice';
import { AppDispatch, RootState } from 'redux/store';
import InfoModal from 'components/Common/InfoModal';
import NoResults from 'components/Common/NoResultsText';

function AccountsAndBalances() {
    const dispatch = useDispatch<AppDispatch>();
    const { moneyContainerList, loading: getContainerLoading } = useSelector((state: RootState) => state.moneyContainer);
    const [modalOpen, setModalOpen] = useState(false);
    const [containerId, setContainerId] = useState<number>(0);
    const [loading, setLoading] = useState(false);

    const handleChangeSwitch = (id: number) => {
        setContainerId(id);
        setModalOpen(true);
    };

    const handelClickConfirm = async () => {
        setLoading(true);
        await dispatch(updatedAccount(containerId?.toString()));
        setLoading(false);
        setModalOpen(false);
    };

    useEffect(() => {
        dispatch(getMoneyContainer());
    }, [dispatch]);

    return (
        <>
            <Container sx={{ width: '100%' }}>
                {!moneyContainerList?.length && (
                    <Stack height={500} justifyContent={'center'}>
                        <NoResults message="You dont have an account." />
                    </Stack>
                )}
                <Stack sx={{ p: 1, alignItems: 'center' }}>
                    {moneyContainerList?.map((item: any, index: any) => {
                        return (
                            <BankAccountCard
                                key={index}
                                bankCardDetails={item}
                                handleChangeSwitch={handleChangeSwitch}
                                getContainerLoading={getContainerLoading}
                            />
                        );
                    })}
                </Stack>
            </Container>
            <InfoModal
                loading={loading}
                description="Are you sure you want to change the active account?"
                isOpen={modalOpen}
                onClose={() => setModalOpen(false)}
                title={'Active Account'}
                onConfirm={handelClickConfirm}
            />
        </>
    );
}

export default AccountsAndBalances;
